import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  TopToolbar,
  EditButton,
  Button,
  ReferenceManyField,
  Datagrid,
  useRecordContext,
  useRedirect,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import type { ShowProps } from "react-admin";
import { Box, Typography } from "@mui/material";

const KarzanActions = () => {
  const record = useRecordContext();
  const redirect = useRedirect();
  return (
    <TopToolbar>
      <EditButton />
      {record?.id ? (
        <Button
          label="Add repayment"
          onClick={() => redirect(`/projectKarzanRepayments/create?projectKarzanId=${record.id}`)}
        />
      ) : null}
    </TopToolbar>
  );
};

export const ProjectKarzanShow = (props: ShowProps) => (
  <Show {...props} actions={<KarzanActions />}>
    <SimpleShowLayout>
      <TextField source="lenderName" emptyText="—" />
      <TextField source="lenderReference" emptyText="—" />
      <NumberField source="principalAmount" options={{ style: "currency", currency: "INR" }} />
      <NumberField source="repaidAmount" options={{ style: "currency", currency: "INR" }} />
      <TextField source="status" />
      <DisplayDateField source="disbursementDate" emptyText="—" />
      <TextField source="remarks" emptyText="—" />
    </SimpleShowLayout>
    <Box sx={{ px: 2, pb: 2 }}>
      <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }} fontWeight={600}>
        Repayments
      </Typography>
      <ReferenceManyField
        reference="projectKarzanRepayments"
        target="projectKarzanId"
        label={false}
      >
        <Datagrid bulkActionButtons={false}>
          <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
          <DisplayDateField source="repaymentDate" />
          <TextField source="remarks" emptyText="—" />
        </Datagrid>
      </ReferenceManyField>
    </Box>
  </Show>
);
